import { render, staticRenderFns } from "./Hjem.vue?vue&type=template&id=6d3c9562&scoped=true&"
var script = {}
import style0 from "./Hjem.vue?vue&type=style&index=0&id=6d3c9562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c9562",
  null
  
)

export default component.exports